import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const ActiveReportItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border: 2px solid ${(props) => props.theme.primary};
  border-radius: 4px;
  background-color: ${(props) => props.theme.background2};
`;

export const ReportsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ReportItem = styled.div<{ isDragging: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border: 1px solid ${(props) => props.theme.border1};
  border-radius: 4px;
  background-color: ${(props) => (props.isDragging ? props.theme.background3 : props.theme.background2)};
  cursor: move;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.background3};
  }

  ${(props) => props.isDragging && `
    opacity: 0.6;
    border: 2px dashed ${props.theme.primary};
  `}
`;

export const ReportLabel = styled.span`
  font-weight: 500;
  color: ${(props) => props.theme.text};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.text2};
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const AddReportContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
`;

export const NoReportsMessage = styled.div`
  padding: 20px;
  text-align: center;
  color: ${(props) => props.theme.text2};
  background-color: ${(props) => props.theme.background2};
  border: 1px dashed ${(props) => props.theme.border1};
  border-radius: 4px;
`;

export const ReportItemStyled = styled.div<{ isDragging: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border: 1px solid ${(props) => props.theme.border1};
  border-radius: 4px;
  background-color: ${(props) => (props.isDragging ? props.theme.background3 : props.theme.background2)};
  cursor: move;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.background3};
  }

  ${(props) => props.isDragging && `
    opacity: 0.6;
    border: 2px dashed ${props.theme.primary};
  `}
`;

export const ReportItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;
